import { bunja } from 'bunja';
import { addHours, isAfter, parseISO } from 'date-fns';
import { atom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';

import { getCurrentKYCStatusApi } from '@flipster/apis/v1/kyc';
import { authBunja } from '@flipster/features/src/shared/auth/state';
import { getLocalStorage } from '@flipster/utils/localStorage';

export const KYC_MODAL_HIDE_TIMESTAMP_KEY = 'flipster.configs.v1.kycModalHideTimestamp';

export const kycPopupBunja = bunja(() => {
  const { isCookieLoggedInAtom } = bunja.use(authBunja);
  const getCurrentKYCStatusApiAtom = atomWithQuery((get) => {
    const isCookieLoggedIn = get(isCookieLoggedInAtom);

    return {
      // fixme: useKYC hook에서 다른 방식으로 api를 호출하고 있음에 따라 query key를 별도로 구분하였음. 추후 통일 필요
      queryKey: ['getCurrentKYCStatusApi', 'withBunja'],
      queryFn: getCurrentKYCStatusApi,
      enabled: isCookieLoggedIn,
    };
  });

  const kycInfoAtom = atom((get) => get(getCurrentKYCStatusApiAtom).data?.data);

  const isShowKycPopupAtom = atom((get) => {
    const kycInfo = get(kycInfoAtom);
    if (!kycInfo?.gracePeriod) return false;

    // 모달은 닫은 시각으로부터 24시간이 지나지 않은 경우 노출하지 않는다
    const hideTimeStamp = getLocalStorage(KYC_MODAL_HIDE_TIMESTAMP_KEY);
    if (hideTimeStamp) {
      const nextShowTime = addHours(parseISO(hideTimeStamp), 24);
      const currentTime = new Date();

      if (isAfter(nextShowTime, currentTime)) return false;
    }

    return true;
  });

  return { kycInfoAtom, isShowKycPopupAtom };
});
